export enum GTMInitializationErrorMessages {
    USER_DOES_NOT_CONSENT = 'Unable to initalize the GTM due the user has not authorised it',
}

export class GTMInitializationError extends Error {
    public errorKey = '[Google Services] GTM_INITIALIZATION_ERROR';

    public errorMessage;

    constructor(message: GTMInitializationErrorMessages) {
        super(message);

        this.errorMessage = message;

        Object.setPrototypeOf(this, GTMInitializationError.prototype);
    }
}
